__turbopack_context__.v({
  "chevronArrow": "hneyxq_chevronArrow",
  "ctaLink": "hneyxq_ctaLink",
  "ctaLinkMobileOnly": "hneyxq_ctaLinkMobileOnly",
});
